import 'reflect-metadata'
import { GdService, ServiceScope } from '@glidecms/deliver-core-dev/services'
import axios from 'axios'

export interface ILatestNewsService {
  getLatestNewsData(category: string)
  getAllCategories()
}

@GdService({
  scope: ServiceScope.Singleton,
})
export class LatestNewsService implements ILatestNewsService {
  private fileLocation = process.env.LATEST_NEWS_FILE_LOCATION
  private latestNewsCache = {}
  private timeout = 60 * 1000 * 5
  private categories = []
  constructor() {
    this.refreshCache()
  }

  public getLatestNewsData = async (category) => {
    if (this.checkIfCategoryExist(category)) {
      return this.latestNewsCache[category]
    } else {
      const url = this.generateUrl(category)
      const data = await this.getDataFromUrl(url)
      if (data) {
        this.saveDataToCache(category, data)
        return data
      }
      return null
    }
  }

  public async getAllCategories() {
    const category = 'categories'

    if (this.checkIfCategoryExist(category)) {
      return this.latestNewsCache[category]
    } else {
      const url = this.generateUrl(category)
      const data = await this.getDataFromUrl(url)
      if (data) {
        this.saveDataToCache(category, data)
        return data
      }
      return null
    }
  }

  private checkIfCategoryExist = (category) => {
    return this.latestNewsCache[category] ? true : false
  }

  private saveDataToCache = (category, data) => {
    this.latestNewsCache[category] = data
  }

  private generateUrl = (category) => {
    return this.fileLocation + category + '.json'
  }

  private refreshCache = () => {
    this.categories = Object.keys(this.latestNewsCache)
    this.categories.forEach(async (category) => {
      const url = this.generateUrl(category)
      const data = await this.getDataFromUrl(url)
      this.latestNewsCache[category] = data
    })

    setTimeout(this.refreshCache, this.timeout)
  }

  private getDataFromUrl = async (url) => {
    try {
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      // if (error.response) {
      //   console.log(error.response.data);
      //   console.log(error.response.status);
      //   console.log(error.response.headers);
      // } else if (error.request) {
      //   console.log(error.request);
      // } else {
      //   console.log('Error', error.message);
      // }
      // console.log(error);
      return null
    }
  }
}
